import BasicModel from '../basic/BasicModel'
export default {
  getPrivateUsedCarConfigById (vm, params, listener) {
    let action = 'privateUsedCar/getPrivateUsedCarConfigById.action'
    BasicModel.get(vm, action, params, listener)
  },
  savePrivateUsedCarConfig (vm, params, listener) {
    let action = 'privateUsedCar/savePrivateUsedCarConfig.action'
    BasicModel.post(vm, action, params, listener)
  },
  editPrivateUsedCarConfig (vm, params, listener) {
    let action = 'privateUsedCar/editPrivateUsedCarConfig.action'
    BasicModel.post(vm, action, params, listener)
  },
  findUsedCarConfigPriceList (vm, params, listener) {
    let action = 'privateUsedCar/findUsedCarConfigPriceList.action'
    BasicModel.get(vm, action, params, listener)
  },
  findUsedCarSingleInfoKv (vm, params, listener) {
    let action = 'privateUsedCar/findUsedCarSingleInfoKv.action'
    BasicModel.get(vm, action, params, listener)
  },
  handTop (vm, params, listener) {
    let action = 'privateUsedCar/handTop.action'
    BasicModel.post(vm, action, params, listener)
  },
  changePrivateUsedCarAuthStatus (vm, params, listener) {
    let action = 'privateUsedCar/changePrivateUsedCarAuthStatus.action'
    BasicModel.post(vm, action, params, listener)
  },
  changeChannelConfigAuthSwitch (vm, params, listener) {
    let action = 'privateUsedCar/changeChannelConfigAuthSwitch.action'
    BasicModel.post(vm, action, params, listener)
  },
  changeGoodsAuthStatus (vm, params, listener) {
    let action = 'lcwpgoods/changeGoodsAuthStatus.action'
    BasicModel.post(vm, action, params, listener)
  },
  findPrivateUsedCarWhiteList (vm, params, listener) {
    let action = 'privateUsedCar/findPrivateUsedCarWhiteList.action'
    BasicModel.get(vm, action, params, listener)
  },
  deletePrivateUsedCarWhite (vm, params, listener) {
    let action = 'privateUsedCar/deletePrivateUsedCarWhite.action'
    BasicModel.post(vm, action, params, listener)
  },
  getChannelConfig (vm, params, listener) {
    let action = 'privateUsedCar/getChannelConfig.action'
    BasicModel.get(vm, action, params, listener)
  },
  saveOrUpdateWhitePhone (vm, params, listener) {
    let action = 'privateUsedCar/saveOrUpdateWhitePhone.action'
    BasicModel.post(vm, action, params, listener)
  },
  getPriveteUsedCarIndex (vm, params, listener) {
    let action = 'privateUsedCar/getPriveteUsedCarIndex.action'
    BasicModel.get(vm, action, params, listener)
  }
}
